import { computed } from 'vue';
import store from '@/store';
import auditorPresenter from '@/presenters/auditor-presenter';
import pricingProductsPresenter from '@/presenters/pricing-products-presenter';

export default class AuditorCode {
	public auditorEntries = computed(() => {
		return store.getters.auditorEntries();
	});

	public async mounted(): Promise<void> {
		await this.loadEssentialData();
		store.mutations.incrementLoadCount();
	}

	private async loadEssentialData(): Promise<void> {
		if (this.auditorEntries.value.length) {
			return;
		}

		await Promise.all([
			await auditorPresenter.retrieveAuditorEntries(),
			await pricingProductsPresenter.retrieveProducts()
		]);
	}
}
